import * as Sentry from '@sentry/react';
import { Fragment, useState, type ReactNode } from 'react';
import ClientErrorPage from './ClientErrorPage';

interface Props {
    children: ReactNode;
}

export default function ClientFormErrorBoundary({ children }: Props) {
    const [remountKey, setRemountKey] = useState(0);

    return (
        <Sentry.ErrorBoundary
            fallback={({ resetError }) => (
                <ClientErrorPage
                    onRetry={() => {
                        setRemountKey((key) => key + 1);
                        resetError();
                    }}
                />
            )}
        >
            <Fragment key={remountKey}>{children}</Fragment>
        </Sentry.ErrorBoundary>
    );
}
